import { enableProdMode, ErrorHandler, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { GlobalErrorHandler, RollbarService, rollbarFactory } from './app/app.module';
import { environment } from './environments/environment';
import { ToastrService } from './app/shared/services/toastr-service';
import { AuthService } from './app/shared/auth/auth.service';
import { RefreshTokenService } from './app/shared/auth/refresh-token.service';
import { AuthGuard } from './app/shared/auth/auth-guard.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthTokenInterceptor } from './app/shared/auth/auth-token-interceptor';
import { NgbDateAdapter, NgbDateNativeUTCAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateITParserFormatter } from './app/NgbDateITParserFormatter';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app-routing.module';
import { Angulartics2Module } from 'angulartics2';
import { NgxCaptchaModule } from 'ngx-captcha';
import { SharedModule } from './app/shared/shared.module';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(AppRoutingModule, Angulartics2Module.forRoot(), NgxCaptchaModule, SharedModule),
        ToastrService,
        AuthService,
        RefreshTokenService,
        { provide: RollbarService, useFactory: rollbarFactory },
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthTokenInterceptor,
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: 'it-IT'
        },
        {
            provide: NgbDateAdapter,
            // useClass: NgbDateNativeAdapter
            useClass: NgbDateNativeUTCAdapter
        },
        {
            provide: NgbDateParserFormatter,
            useClass: NgbDateITParserFormatter
        },
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ]
});
